import { Context } from '@nuxt/types'

import config from '../config/'

function meta(name: string = '', content: string = '', extend: object = {}): object {
  return {
    name,
    hid: name,
    content,
    ...extend
  }
}

function metaProperty(property: string = '', content: string = '', extend: object = {}): object {
  return {
    property,
    hid: property,
    content,
    ...extend
  }
}

function link(rel: string = '', href: string = '', type: string = '', extend: object = {}) {
  return {
    rel,
    type,
    href,
    ...extend
  }
}

function setMetaTitleAndDescription(
  title: string = config.title,
  description: string = config.description,
  titleTemplate: boolean = true
): Array<any> {
  return [
    metaProperty('og:title', title, { template: titleTemplate ? config.titleTemplate : undefined }),
    meta('twitter:title', title, { template: titleTemplate ? config.titleTemplate : undefined }),

    meta('description', description),
    metaProperty('og:description', description),
    meta('twitter:description', description)
  ]
}

let pageScrollY = 0
const blockScroll = (scrollY?: number) => {
  pageScrollY = scrollY || 0

  document.body.style.position = 'fixed'
  document.body.style.top = `-${scrollY}px`
  document.body.style.width = '100vw'
  document.body.style.height = '100vh'
  document.body.style.overflow = 'hidden'
}

const enableScroll = () => {
  document.body.style.removeProperty('position')
  document.body.style.removeProperty('top')
  document.body.style.removeProperty('width')
  document.body.style.removeProperty('height')
  document.body.style.removeProperty('overflow')

  window.scrollTo(0, pageScrollY)
}

function handleError(err: Error) {
  // eslint-disable-next-line no-console
  console.log(err)
}

function debounce(func: Function, wait: number = 20) {
  let timeout: any
  return function executedFunction(...args: any) {
    const later = () => {
      timeout = null
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

export {
  blockScroll,
  debounce,
  enableScroll,
  handleError,
  link,
  meta,
  metaProperty,
  setMetaTitleAndDescription
}

const helper = {
  meta,
  metaProperty,
  link,
  setMetaTitleAndDescription,
  handleError,
  blockScroll,
  enableScroll,
  debounce
}
export type HelperType = typeof helper
export default (ctx: Context, inject: any) => {
  ctx.$helper = helper
  inject('helper', helper)
}
